var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTareas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#004c7b;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 400") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "19.93 5 23 5 23 31 1 31 1 5 4.02 5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,7V3H14a2,2,0,0,0-4,0H7V7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.99,
    y1: 17,
    x2: 5.99,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.99,
    y1: 21,
    x2: 5.99,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.99,
    y1: 25,
    x2: 5.99,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.99,
    y1: 13,
    x2: 5.99,
    y2: 13
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTareas);
export default __webpack_public_path__ + "static/media/tareas.a4bb04150364e0be59e21f31882f21f5.svg";
export { ForwardRef as ReactComponent };